import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foeaddrbookApi = api
  .enhanceEndpoints({ addTagTypes: ['FOEAddrBook'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOEAddrBooks: builder.query<fo_eaddrbook[], string>({
        query: cid => `foeaddrbook/${cid}`,
        providesTags: ['FOEAddrBook']
      }),
      getFOHistory: builder.query<any, any>({
        query: ({ cid, mobile }) => `foeaddrbook/history/${cid}/${mobile}`,
        providesTags: ['FOEAddrBook']
      }),
      getFOEAddrBook: builder.query<fo_eaddrbook, string>({
        query: id => `foeaddrbook/byid/${id}`
      }),
      getAddress: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `foeaddrbook/ocropenai`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['FOEAddrBook']
      }),
      importFOEAddrBook: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `foeaddrbook/import`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['FOEAddrBook']
      }),
      insertFOEAddrBook: builder.mutation({
        query: foeaddrbook => ({
          url: `foeaddrbook/`,
          method: 'POST',
          body: foeaddrbook
        }),
        invalidatesTags: ['FOEAddrBook']
      }),
      updateFOEAddrBook: builder.mutation({
        query: foeaddrbook => ({
          url: `foeaddrbook/`,
          method: 'PUT',
          body: foeaddrbook
        }),
        invalidatesTags: ['FOEAddrBook']
      }),
      deleteFOEAddrBook: builder.mutation({
        query: foeaddrbook => ({
          url: `foeaddrbook/${foeaddrbook.ab_id}`,
          method: 'DELETE',
          body: foeaddrbook
        }),
        invalidatesTags: ['FOEAddrBook']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOEAddrBooksQuery,
  useLazyGetFOHistoryQuery,
  useGetFOEAddrBookQuery,
  useGetAddressMutation,
  useImportFOEAddrBookMutation,
  useInsertFOEAddrBookMutation,
  useUpdateFOEAddrBookMutation,
  useDeleteFOEAddrBookMutation
} = foeaddrbookApi;

